import { z } from 'zod';
import { OnboardingFormFields } from '@Types/index.ts';
import { Line1Schema } from '@Components/inputs/Line1';
import { AddressStateSchema } from '@Components/inputs/AddressStateDropDown';
import { zipSchema } from '@Components/inputs/ZipAddress';
import { citySchema } from '@Components/inputs/CityInput';

export const MailingAddressSchema = z.object({
  ...Line1Schema.shape,
  [OnboardingFormFields.APARTMENT]: z.string().optional(),
  ...citySchema.shape,
  ...zipSchema.shape,
  ...AddressStateSchema.shape,
});
